import { Injectable } from '@angular/core';
import { snackbarService } from '@one/web-components';


@Injectable({
    providedIn: 'root'
})
export class SnackBarService {

    constructor() { }

    showSnackBar(message: string, status: 'positive' | 'alert' | 'warning') {
        snackbarService.show({
            message,
            snackbarProps: {
                duration: 5000,
                showClose: true,
                status,
                variant: 'secondary',
                direction: 'horizontal'
            }
        })
    }

    displaySnackBar(text: string, status: 'positive' | 'alert' | 'warning') {
        return this.showSnackBar(text, status);
    }

}
